import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import { stuclasslist, studivisionlist } from "../../../services/master";
import { academylist } from "../../../services/admin";
import { studentfilter } from "../../../services/student";

// ID Card report. Filter students by academy (super-admin), class and section
// and list the details printed on the ID card, with CSV export.
const COLUMNS = [
  { headerName: "Name", field: "student_name" },
  { headerName: "Username", field: "username" },
  { headerName: "Gender", field: "gender" },
  { headerName: "Class", field: "class_name" },
  { headerName: "Section", field: "section_name" },
  { headerName: "Mobile", field: "phone" },
  { headerName: "Academy", field: "academy_name" },
];

const columnDefs = COLUMNS.map((col) => ({
  ...col,
  sortable: true,
  resizable: true,
  filter: true,
  floatingFilter: true,
  cellStyle: { textAlign: "left" },
}));

const IdCardReport = () => {
  const isSuperAdmin = localStorage.getItem("Role") === "1";
  const gridRef = useRef();

  const [aclist, setACList] = useState([]);
  const [acaid, setAcaID] = useState("");
  const [clist, setCList] = useState([]);
  const [sclass, setSClass] = useState("");
  const [divlist, setDivList] = useState([]);
  const [studiv, setStuDiv] = useState("");
  const [rowData, setRowData] = useState([]);

  useEffect(() => {
    stuclasslist().then((res) => {
      if (res.status === true && res.data.length > 0) {
        setCList(
          res.data.map((item) => ({ value: item.id, label: item.class_name }))
        );
      }
    });

    studivisionlist().then((res) => {
      if (res.status === true && res.data.length > 0) {
        setDivList(
          res.data.map((item) => ({ value: item.id, label: item.name }))
        );
      }
    });

    academylist().then((res) => {
      if (res.status === true && res.data.details.length > 0) {
        const arr = res.data.details.map((item) => ({
          value: item.id,
          label: item.name + " - " + item.code,
        }));
        setACList(arr);

        // Default to the academy chosen at login (matches other report screens).
        let defaultAca = "";
        if (localStorage.getItem("AAcademy") != null) {
          defaultAca =
            arr.find((a) => a.value == localStorage.getItem("AAcademy")) || "";
          if (defaultAca) setAcaID(defaultAca);
        }
        listall(defaultAca, "", "");
      } else {
        listall("", "", "");
      }
    });
  }, []);

  function listall(aca, cl, se) {
    setRowData([]);
    const temp = new FormData();
    temp.append("year", "");
    temp.append("class", cl ? cl.value : "");
    temp.append("section", se ? se.value : "");
    temp.append("student", "");
    if (isSuperAdmin && aca && aca.value) {
      temp.append("academy", aca.value);
    }
    studentfilter(temp).then((res) => {
      if (res.status === true) {
        setRowData(res.data.details || []);
      }
    });
  }

  function handleAcademy(e) {
    setAcaID(e || "");
    listall(e || "", sclass, studiv);
  }

  function handleClass(e) {
    setSClass(e || "");
    listall(acaid, e || "", studiv);
  }

  function handleSection(e) {
    setStuDiv(e || "");
    listall(acaid, sclass, e || "");
  }

  const exportToCSV = () => {
    const q = (v) => `"${(v == null ? "" : String(v)).replace(/"/g, '""')}"`;
    // Selected-filter context, prepended above the exported grid.
    const prependContent =
      [
        ["Class", sclass ? sclass.label : "All"],
        ["Section", studiv ? studiv.label : "All"],
      ]
        .map((row) => row.map(q).join(","))
        .join("\n") + "\n\n";

    gridRef.current.api.exportDataAsCsv({
      fileName: "ID Card Report.csv",
      allColumns: true,
      prependContent,
    });
  };

  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">ID Card Report</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Reports</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            ID Card Report
          </li>
        </ol>
      </div>
      <div className="content-body">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header">
              <h2 className="main-content-title tx-24 mg-b-5">ID Card Report</h2>
            </div>
            <div className="card-body">
              <div className="row">
                {isSuperAdmin && (
                  <div className="col-xl-3 col-sm-6">
                    <label className="form-label">Select Academy</label>
                    <Select
                      className="default-select"
                      placeholder="Select Academy"
                      value={acaid}
                      options={aclist}
                      onChange={handleAcademy}
                      isSearchable={true}
                      isClearable
                    />
                  </div>
                )}

                <div className="col-xl-3 col-sm-6">
                  <label className="form-label">Select Class</label>
                  <Select
                    className="default-select"
                    placeholder="Select Class"
                    value={sclass}
                    options={clist}
                    onChange={handleClass}
                    isSearchable={true}
                    isClearable
                  />
                </div>

                <div className="col-xl-3 col-sm-6">
                  <label className="form-label">Select Section</label>
                  <Select
                    className="default-select"
                    placeholder="Select Section"
                    value={studiv}
                    options={divlist}
                    onChange={handleSection}
                    isSearchable={true}
                    isClearable
                  />
                </div>

                <div className="col-xl-3 col-sm-6">
                  <div className="res-right mt-5">
                    <button
                      className="btn btn-success me-2"
                      onClick={exportToCSV}
                      disabled={rowData.length === 0}
                    >
                      Excel Download
                    </button>
                  </div>
                </div>
              </div>

              <div className="ag-theme-alpine ag-style mt-2">
                <AgGridReact
                  ref={gridRef}
                  columnDefs={columnDefs}
                  rowData={rowData}
                  pagination="true"
                  paginationPageSize="10"
                  sortingOrder={["asc", "desc"]}
                  suppressDragLeaveHidesColumns={true}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IdCardReport;
